import React from 'react';
const Comment = ({ ...r }) => {
  return(
  <svg 
    width="20" 
    height="21" 
    viewBox="0 0 20 21" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 0.998657H8C5.87827 0.998657 3.84344 1.84151 2.34315 3.3418C0.842855 4.84209 0 6.87693 0 8.99866C0 15.4987 7 18.4987 12 20.4987V16.9987C14.1217 16.9987 16.1566 16.1558 17.6569 14.6555C19.1571 13.1552 20 11.1204 20 8.99866C20 6.87693 19.1571 4.84209 17.6569 3.3418C16.1566 1.84151 14.1217 0.998657 12 0.998657ZM10 14.9987V17.4787C4.462 14.9647 2 12.6087 2 8.99866C2 7.40736 2.63214 5.88124 3.75736 4.75602C4.88258 3.6308 6.4087 2.99866 8 2.99866H12C12.7879 2.99866 13.5681 3.15385 14.2961 3.45538C15.0241 3.75691 15.6855 4.19887 16.2426 4.75602C16.7998 5.31317 17.2417 5.9746 17.5433 6.70256C17.8448 7.43051 18 8.21073 18 8.99866C18 9.78659 17.8448 10.5668 17.5433 11.2948C17.2417 12.0227 16.7998 12.6841 16.2426 13.2413C15.6855 13.7984 15.0241 14.2404 14.2961 14.5419C13.5681 14.8435 12.7879 14.9987 12 14.9987H10ZM7 7.99866H5V9.99866H7V7.99866ZM9 7.99866H11V9.99866H9V7.99866ZM15 7.99866H13V9.99866H15V7.99866Z" fill="#272727"/>
  </svg>

  );}

export default Comment;